import React from 'react';
import { Link } from 'react-router-dom';
import { FaCreditCard, FaLock, FaShieldAlt, FaClock, FaEuroSign, FaCheckCircle } from 'react-icons/fa';
import './PaymentSection.css';

const PaymentSection = () => {
  return (
    <section className="payment-section" id="payment">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">PAIEMENT</span>
          <h2 className="section-title">
            Des conditions de <span className="text-gradient">paiement simples</span>
          </h2>
          <p className="section-description">
            Des modalités transparentes pour votre déménagement
          </p>
        </div>

        {/* Cartes principales */}
        <div className="payment-cards">
          <div className="payment-card-main acompte">
            <div className="payment-percentage">30%</div>
            <div className="payment-icon">🔒</div>
            <h3>Acompte à la réservation</h3>
            <p>Un acompte de <strong>30% du montant total</strong> est demandé à la confirmation de votre rendez-vous pour bloquer votre créneau.</p>
          </div>
          <div className="payment-card-main solde">
            <div className="payment-percentage">70%</div>
            <div className="payment-icon">💰</div>
            <h3>Solde à la livraison</h3>
            <p>Les <strong>70% restants</strong> sont à régler le jour même de votre déménagement, après la prestation.</p>
          </div>
        </div>
        
        {/* Grille des informations */}
        <div className="payment-grid">
          <div className="payment-info-card">
            <FaCreditCard className="info-icon" />
            <h4>Moyens de paiement</h4>
            <ul>
              <li><FaCheckCircle /> Carte bancaire</li>
              <li><FaCheckCircle /> Virement bancaire</li>
              <li><FaCheckCircle /> Espèces</li>
            </ul>
          </div>

          <div className="payment-info-card">
            <FaLock className="info-icon" />
            <h4>Paiement sécurisé</h4>
            <ul>
              <li><FaCheckCircle /> Transactions 100% sécurisées</li>
              <li><FaCheckCircle /> Aucune donnée conservée</li>
              <li><FaCheckCircle /> Cryptage SSL</li>
            </ul>
          </div>

          <div className="payment-info-card">
            <FaShieldAlt className="info-icon" />
            <h4>Garanties</h4>
            <ul>
              <li><FaCheckCircle /> Devis gratuit</li>
              <li><FaCheckCircle /> Prix fixes</li>
              <li><FaCheckCircle /> Assurance incluse</li>
            </ul>
          </div>
    
        </div>

      </div>
    </section>
  );
};

export default PaymentSection;